var Ajaxinate = function ajaxinateConstructor(config) {
    var settings = config || {};
    var defaultSettings = {
        method: 'scroll',
        container: '#main-collection-product-grid',
        pagination: '#actionPagination',
        offset: 0,
        loadingText: `<div class="BouncingSpinner"><span></span> </div>`,
        callback: null
    };

    // Merge configs
    this.settings = Object.assign(defaultSettings, settings);

    this.addScrollListeners = this.addScrollListeners.bind(this);
    this.addClickListener = this.addClickListener.bind(this);
    this.addClickListener = this.addClickListener.bind(this);

    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
    this.removeClickListener = this.removeClickListener.bind(this);
    this.removeScrollListener = this.removeScrollListener.bind(this);
    this.destroy = this.destroy.bind(this);

    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);
    this.initialize();
};



Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
    if (this.containerElement) {
        var initializers = {
            click: this.addClickListener,
            scroll: this.addScrollListeners
        };
        initializers[this.settings.method]();
    }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
    if (this.paginationElement) {
        document.addEventListener('scroll', this.checkIfPaginationInView);
        window.addEventListener('resize', this.checkIfPaginationInView);
        window.addEventListener('orientationchange', this.checkIfPaginationInView);
    }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
    if (this.paginationElement) {
        this.nextPageLinkElement = this.paginationElement.querySelector('a');
        this.clickActive = true;
        if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
            this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
        }
    }
};

Ajaxinate.prototype.addCustomEventListener = function reInit() {
    document.addEventListener('resetpagination', function(){

    });
}

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
    event.preventDefault();
    if (this.clickActive) {
        this.nextPageLinkElement.querySelector('a .showmore-text').innerHTML = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.clickActive = false;
        this.loadMore();
    }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
    var top = document.getElementById('actionPagination').getBoundingClientRect().top - this.settings.offset;
    var bottom = document.getElementById('actionPagination').getBoundingClientRect().bottom + this.settings.offset;
    if (top <= window.innerHeight && bottom >= 0) {
        this.nextPageLinkElement = document.getElementById('actionPagination').querySelector('a');
        this.removeScrollListener();
        if (this.nextPageLinkElement) {

            this.nextPageLinkElement.innerHTML = this.settings.loadingText;
            this.nextPageUrl = this.nextPageLinkElement.href;
            this.loadMore();
        }
    }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
    this.request = new XMLHttpRequest();
    this.request.onreadystatechange = function success() {

        if (this.request.readyState === 4 && this.request.status === 200) {

            var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
            var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
            this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
            document.getElementById('actionPagination').innerHTML = newPagination.innerHTML;
            const prod_count = (this.request.responseXML.querySelector('#main-collection-product-grid') && this.request.responseXML.querySelector('#main-collection-product-grid > .product-index')) ? this.request.responseXML.querySelectorAll('#main-collection-product-grid > .product-index').length : 0;
            if (document.querySelector('.showmore-counter .load-more-prod-count')){
                document.querySelector('.showmore-counter .load-more-prod-count').textContent = parseInt(document.querySelector('.showmore-counter .load-more-prod-count').textContent) + prod_count;
            }

            if (this.settings.callback && typeof this.settings.callback === 'function') {
                this.settings.callback(this.request.responseXML);
            }
            document.dispatchEvent(new Event('inizializeScroolMagicForNew'));
            this.initialize();
        }
    }.bind(this);

    this.request.open('GET', this.nextPageUrl, true);
    this.request.responseType = 'document';
    this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
    this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
    document.removeEventListener('scroll', this.checkIfPaginationInView);
    window.removeEventListener('resize', this.checkIfPaginationInView);
    window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
    var destroyers = {
        click: this.removeClickListener,
        scroll: this.removeScrollListener
    };
    destroyers[this.settings.method]();
    return this;
};

